import Separator from '@doordash/component-separator'
import { Inset, Icon, Colors, Stack, Text } from '@doordash/design-language'
import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import {
  ListMenuContainer,
  ProgressLine,
  ListIcon,
  ListTitleContainer,
  ListMenu,
  ContentContainer,
} from './styles'

type ProgressionListItemProps = {
  isActive: boolean
  title: string
  isComplete: boolean
  step: number
  isSeparatorShown?: boolean
} & ComponentPropsWithoutRef<'div'>

const ProgressionListItem: React.FC<ProgressionListItemProps> = ({
  isActive,
  title,
  isComplete = false,
  isSeparatorShown = true,
  step,
  children,
  ...props
}) => {
  return (
    <ListMenuContainer {...props}>
      <ProgressLine isComplete={isComplete} />
      <ListIcon
        isActive={isActive}
        isComplete={isComplete}
        size={Inset.Sizes.XxxSmall}
      >
        {isComplete ? (
          <Icon
            type={Icon.Types.Check}
            size={Icon.Sizes.Medium}
            color={Colors.SystemWhite}
          />
        ) : (
          <Text
            color={!isActive ? Colors.SystemGrey60 : Colors.SystemBlack}
            styles={Text.Styles.ListRowTitleLarge}
          >
            {step}
          </Text>
        )}
      </ListIcon>
      <ListTitleContainer>
        <Inset isStretched={true} size={Inset.Sizes.XxxSmall}>
          <ListMenu disabled={true}>
            <Text
              display={Text.DisplayModes.Flex}
              textAlign={Text.TextAlignments.Center}
              styles={
                isActive
                  ? Text.Styles.ListRowTitleLarge
                  : Text.Styles.ListRowSecondaryLarge
              }
              overflow={Text.Overflows.BreakWord}
            >
              {title}
            </Text>
          </ListMenu>
          {isActive && (
            <ContentContainer>
              <Stack size={Stack.Sizes.XxSmall} />
              {!isComplete && children}
            </ContentContainer>
          )}
        </Inset>
        {isSeparatorShown && (
          <Separator
            verticalMargin={Separator.Sizes.Small}
            type={Separator.Types.FullBorder}
          />
        )}
      </ListTitleContainer>
    </ListMenuContainer>
  )
}

export default ProgressionListItem
